"use client";
import { IBlocks, ITheme, IUserData } from "@/types";
import React from "react";
import { BlockUpdateFunction } from ".";
import { getTextColorForBackground } from "@/lib/utils";
import LoadingSkeleton from "./LoadingSkeleton";
import AdminPopover from "../../content/AdminPopover";
import YoutubeVideoLatestOptions from "./tabs/youtubeVideoLatest/options";
import BlockToggle from "./tabs/toggle";
import { Separator } from "@/components/ui/separator";
import BlockMetadata from "./tabs/metadata";

interface Props {
    admin?: boolean;
    user: IUserData;
    block: IBlocks;
    update: BlockUpdateFunction;
    theme: ITheme;
    newBlock?: string | null;
}
export default function BlockYoutubeVideoLatest({
    admin,
    user,
    block,
    update,
    theme,
    newBlock,
}: Props) {
    const [isExpanded, setIsExpanded] = React.useState(false);
    React.useEffect(() => {
        if (newBlock === block.id) {
            handleExpand();
        }
        return () => {
            window.removeEventListener("closeBlock", handleClose);
        };
    }, [newBlock]);
    React.useEffect(() => {
        window.addEventListener("closeBlock", {
            handleEvent: (event: CustomEvent) => {
                if (event.detail.id != block.id) {
                    if (isExpanded) {
                        setIsExpanded(false);
                    }
                }
            },
        });
    });
    React.useEffect(() => {
        if (block != blockUpdate) {
            setBlockUpdate(block);
        }
    }, [block]);
    const handleClose = () => {
        setIsExpanded(false);
        window.dispatchEvent(new CustomEvent("collapseBlock"));
    };
    const text_color = theme.text_col_heading
        ? theme.text_col_heading
        : getTextColorForBackground(theme.background);
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const [youtube, setYoutube] = React.useState<any>(null);
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                let Getvid = await fetch(
                    process.env.NEXT_PUBLIC_API_SERVER + "/youtube/",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            channel_id: blockUpdate.url,
                        }),
                    }
                );
                setYoutube(await Getvid.json());
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        if (blockUpdate.url.length > 0) {
            fetchData();
        }
    }, [blockUpdate, user]);
    function handleUpdate(value: IBlocks) {
        if (value == null) {
            update(blockUpdate.id, value, true);
            return;
        }
        setBlockUpdate({
            ...blockUpdate,
            ...value,
        });
        if (block == value) return;
        update(blockUpdate.id, value);
    }
    const event = new CustomEvent("expandBlock", {
        detail: {
            id: blockUpdate.id,
            title: "Latest YouTube Video",
            titleOptions: (
                <BlockToggle
                    block={blockUpdate}
                    blockUpdate={setBlockUpdate}
                    update={handleUpdate}
                />
            ),
            content: (
                <div className="flex flex-col gap-3 pb-3">
                    <YoutubeVideoLatestOptions
                        block={blockUpdate}
                        blockUpdate={setBlockUpdate}
                        update={handleUpdate}
                    />
                    <BlockMetadata block={blockUpdate} update={handleUpdate} />
                </div>
            ),
        },
    });
    const handleExpand = () => {
        window.dispatchEvent(
            new CustomEvent("closeBlock", {
                detail: {
                    id: block.id,
                },
            })
        );
        setIsExpanded(true);
        window.dispatchEvent(event);
    };
    React.useEffect(() => {
        if (isExpanded) {
            window.dispatchEvent(event);
        }
    }, [blockUpdate]);
    return (
        <AdminPopover
            admin={admin}
            className={block.show ? "" : "opacity-30"}
            title={`Latest Video - ${blockUpdate.url}`}
            onClick={handleExpand}
            isOpen={isExpanded}
            onClose={handleClose}
        >
            {youtube && youtube.data ? (
                <a
                    className="relative flex w-full flex-col"
                    style={{ color: text_color }}
                    href={youtube.data.link}
                    target="_blank"
                >
                    {(() => {
                        const titleParts = [];
                        if (block.options?.show_custom_title) {
                            titleParts.push(block.name);
                        }
                        if (!block.options?.hide_title) {
                            titleParts.push(youtube.data.title);
                        }
                        const title = titleParts.join(" ");
                        return title ? <h4>{title}</h4> : null;
                    })()}

                    <div
                        className="relative"
                        style={{ display: "inline-block" }}
                    >
                        <img
                            src={youtube.data.thumbnail}
                            loading="lazy"
                            id="youtube-video-latest"
                            style={{ borderRadius: "12px" }}
                            className="aspect-video h-full w-full object-cover"
                            // width="100%"
                            // height="100%"
                            alt="Latest YouTube Video"
                        ></img>
                        <div
                            className="absolute"
                            style={{
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                            }}
                        >
                            <img
                                src="https://cdn.doras.to/doras/Youtube_logo.webp"
                                className="z-50 w-20 text-[#FF0000]"
                                alt="YouTube"
                            />
                        </div>
                    </div>
                </a>
            ) : (
                <LoadingSkeleton />
            )}
        </AdminPopover>
    );
}
